// Internal Imports
import { GRID } from "../constants";

// Destructuring
const { PRICING_METHODS } = GRID;

const INITIAL_PRICING_METHOD = {
  view: PRICING_METHODS.FLAT_PRICE,
  product: "",
  flat: {},
  matrix: {
    basePrice: 0,
    errMsg: "",
    range: [{ min: 0, max: "", value: "" }],
  },
  bundle: {
    basePrice: 0,
    bundleType: "basic",
    bundles: [],
    isAdhoc: false,
    products: [],
    searchTxt: "",
    showSearch: true,
    showSuggestion: false,
    value: 0,
  },
  percentageOfTotal: {
    priceListItems: [],
    products: [],
    searchTxt: "",
    showSearch: false,
    showSuggestion: false,
    sourceColumn: "ext_base_price",
    value: 0,
  },
  diyPricing: {
    minPrice: 0,
  },
  includeSkuInPercentageOfTotal: false, // This key is used for all types of pricing methods
};

const DEAFULT_REQUIRED_FIELDS = ["product", "charge_type", "uom"];

export default (
  state = {
    colVisibility: [],
    columnDefs: [],
    metaData: {},
    pricelists: [],
    products: [],
    unusedProducts: [],
    clauses: [],
    props: {},
    rowData: [],
    formRowData: {},
    formDummyFields: {},
    // customJSON: [],
    pricingMethodData: JSON.parse(JSON.stringify(INITIAL_PRICING_METHOD)),
    pbItemEditorRequiredFields: DEAFULT_REQUIRED_FIELDS,
  },
  action,
) => {
  switch (action.type) {
    case "ADD_PRICELISTS":
      return {
        ...state,
        pricelists: action.payload,
      };
    case "REACTION_PRICEBOOK_INIT_DATA":
      return {
        ...state,
        columnDefs: action.payload[0].columnDefs,
        customColumnDefs: action.payload[0].customColumnDefs,
        metaData: action.payload[0].metaData,
        products: action.payload[2],
        clauses: action.payload[3],
        props: action.payload[0].props,
        rowData: action.payload[1].rowData,
      };
    case "UPDATE_ROW_DATA":
      return {
        ...state,
        rowData: action.payload,
      };
    case "REACTION_PRICEBOOK_ADD_COLUMN":
      return {
        ...state,
        columnDefs: action.payload[1].columnDefs,
        customColumnDefs: action.payload[1].customColumnDefs,
        metaData: action.payload[1].metaData,
        props: action.payload[1].props,
      };
    case "REACTION_COLUMN_VISIBILITY":
      return {
        ...state,
        colVisibility: action.payload,
      };
    case "UNUSED_PRODUCTS":
      return {
        ...state,
        unusedProducts: action.payload,
      };
    case "FORM_ROW_DATA":
      return {
        ...state,
        formRowData: action.payload,
      };
    case "FORM_DUMMY_FIELDS":
      return {
        ...state,
        formDummyFields: action.payload,
      };
    case "UPDATE_PRICING_METHOD_DATA":
      return {
        ...state,
        pricingMethodData: action.payload,
      };
    case "NUKE_PRICELIST_FORM":
      return {
        ...state,
        formRowData: {},
        formDummyFields: {},
        pricingMethodData: JSON.parse(JSON.stringify(INITIAL_PRICING_METHOD)),
        pbItemEditorRequiredFields: DEAFULT_REQUIRED_FIELDS,
      };
    case "PB_ITEM_EDITOR_REQUIRED_FIELDS":
      return {
        ...state,
        pbItemEditorRequiredFields: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/PricebookReducer.js